import axios from 'axios'
import { endpoints } from './endpoints';

const chatMessageEndpoints = endpoints.chatMessage;

export function getAll(chatId: string, shared: boolean = false) {
  return axios.get(chatMessageEndpoints.getAll(chatId, shared))
}

export function sendAndGetResponse(chatId: string, languageCode: string, data: any, signal?: any) {
    return axios.post(chatMessageEndpoints.sendAndGetResponse(chatId), data, {signal: signal, headers: {
      'Content-Type': 'multipart/form-data'
    }})
}

export function getResponse(chatId: string, chatMessageId: number, signal?: any) {
    return axios.post(chatMessageEndpoints.getResponse(chatId, chatMessageId), {}, {signal: signal})
}

export function isAttributable(chatId: string, chatMessageId: number) {
    return axios.get(chatMessageEndpoints.isAttributable(chatId, chatMessageId))
}

export function attribute(chatId: string, chatMessageId: number) {
    return axios.post(chatMessageEndpoints.attribute(chatId, chatMessageId))
}

export function delete_(chatId: string, chatMessageId: number) {
    return axios.delete(chatMessageEndpoints.delete(chatId, chatMessageId))
}

export function getFile(chatId: string, chatMessageId: number, type: string, shared: boolean = false) {
    return axios.get(chatMessageEndpoints.getFile(chatId, chatMessageId, type, shared))
}

export function generateFile(chatId: string, chatMessageId: number, type: string, isSystemMessage: boolean) {
    return axios.get(chatMessageEndpoints.generateFile(chatId, chatMessageId, type, isSystemMessage))
}

export function getUploadedFile(chatId: string, chatUploadedFileId: string, shared: boolean = false, as_thumbnail: boolean = false) {
    return axios.get(chatMessageEndpoints.getUploadedFile(chatId, chatUploadedFileId, shared) + (as_thumbnail ? '?as_thumbnail' : ''))
}

export function diacritize(chatId: string, chatMessageId: number, isSystemMessage: boolean) {
    return axios.get(chatMessageEndpoints.diacritize(chatId, chatMessageId, isSystemMessage))
}

export function searchImages(chatId: string, chatMessageId: number, isSystemMessage: boolean) {
    return axios.get(chatMessageEndpoints.searchImages(chatId, chatMessageId, isSystemMessage))
}

export function translate(chatId: string, chatMessageId: number, isSystemMessage: boolean) {
    return axios.get(chatMessageEndpoints.translate(chatId, chatMessageId, isSystemMessage))
}

export function react(chatId: string, chatMessageId: number, reaction: string, attributionId?: string,  fileId?: number) {
    return axios.post(chatMessageEndpoints.react(chatId, chatMessageId), {'file_id': fileId, 'reaction':reaction, 'attribution_id':attributionId})
}

export function submitFeedback(chatId: string, chatMessageId: number, data: any) {
    return axios.post(chatMessageEndpoints.submitFeedback(chatId, chatMessageId), data)
}